var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M9.156 14.544C10.899 13.01 14 9.876 14 7A6 6 0 102 7c0 2.876 3.1 6.01 4.844 7.544a1.736 1.736 0 002.312 0zM6 7a2 2 0 114 0 2 2 0 01-4 0z","fill":"#fff"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }